/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function() {
  
  $( "#premise-form" ).submit(function( event ) {
    $form = $("#premise-form");
    if($form.data('zipValidated')) {
      // zip has been validated.  Submit form regularly
      return true;
    }
    var inputZip = $('#premise-form').find('input#zipcode').val().replace(/\s/g,'');
    var endpoint = "https://mvsleadmanager.com/api/v1/distributor/zip" + inputZip;
    
    $.ajax({
    	url: endpoint,
      type: "GET",
      dataType: "JSON",
      success: function (data) {
        if(data.distributor ) {
          // zip has been validated.  Resubmit.
          $form.data('zipValidated', true);
          $("#premise-form").submit();
        } else {
          console.log('no data', data)
          window.location.replace("https://www.mountainvalleyspring.com/pages/no-delivery");
        }
      },
      error: function (error) {
        event.preventDefault();
        event.stopPropagation();
        console.log(error);
      //	window.location.replace("https://www.mountainvalleyspring.com/pages/no-delivery");
      }
    });
    
    // abort the standard submit handler.  If we got here
    // we haven't validated the zip yet.
    return false;
  });


  
  $('#premise-submit').click( function(e) {
        var wrap = $(this).parent().parent().parent();
        var inputZip = $('#premise-form').find('input#zipcode').val();
        var endpoint = "https://mvsleadmanager.com/api/v1/distributor/zip" + inputZip;
        
        var requestOptions = {
          method: 'GET',
          redirect: 'follow'
        };
        
        fetch(endpoint, requestOptions)
          .then((response) => response.text())
          .then((result) => {
            var res = JSON.parse(result),
              companyId = res.distributor.distributor.id,
              companySrc = res.distributor.distributor.company,
              localZip = res.user_zip.zipcode.zipcode;

            var comp2 = companySrc.replace(/[^a-zA-Z ]/g, "");
            console.log(comp2);

            var company = comp2,
              comp = company.split(" ").join("-"),
              tolo = comp.toLowerCase();

//             window.location.replace(
//               "/a/distributors/" + companyId + "/" + tolo + "/" + localZip);
//             console.log("oks");
          
             $("#premise-form").submit(function () {});
          })
          .catch((error) => {
          	
            window.location.replace("https://www.mountainvalleyspring.com/pages/no-delivery");
          });
    
    
    
  });
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const success = urlParams.get('success');
  
  console.log(success);
  if(success == 'true') {
    $('#premise-form, .premise-head, .premise2').hide();
  	$('.success').show();
    $('.home-video').hide();
    $('.form-wrapper').addClass('success');
  }
  if($('.form-delivery').length){
      $('.form-delivery button').click(function(){
        var wrap = $(this).parent().parent().parent();
        var inputZip = $(this).parent().parent().parent().find('.col-input input').val();
        var endpoint = "https://mvsleadmanager.com/api/v1/distributor/zip" + inputZip;
        
        var requestOptions = {
          method: 'GET',
          redirect: 'follow'
        };
        
        fetch(endpoint, requestOptions)
          .then((response) => response.text())
          .then((result) => {
            var res = JSON.parse(result);
            var companyId = res.distributor.distributor.id;
            var companySrc = res.distributor.distributor.company;
            var localZip = res.user_zip.zipcode.zipcode;

            var comp2 = companySrc.replace(/[^a-zA-Z ]/g, "");

            var company = comp2,
              comp = company.split(" ").join("-"),
              tolo = comp.toLowerCase();

            if (localZip.length === 5) {
              window.location.replace(
                "/a/distributors/" + companyId + "/" + tolo + "/" + localZip);
            } else {
              window.location.replace(
                "/a/distributors/" + companyId + "/" + tolo);
            }
          })
          .catch((error) => {
          	
            window.location.replace("https://www.mountainvalleyspring.com/pages/no-delivery");
//             console.log("err");
//             wrap.find(".err").show();
//             setTimeout(function () {
//               wrap.find(".err").hide();
//             }, 3000);
          });
        
    })
      
	$('.form-delivery').find('input').keypress(function(e) {
          // Enter pressed?
          if(e.which == 10 || e.which == 13) {
            
            
        var wrap = $(this).parent().parent().parent();
        var inputZip = $(this).parent().parent().parent().find('.col-input input').val();
        var endpoint = "https://mvsleadmanager.com/api/v1/distributor/zip" + inputZip;
        var requestOptions = {
          method: 'GET',
          redirect: 'follow'
        };
        
        fetch(endpoint, requestOptions)
          .then((response) => response.text())
          .then((result) => {
            var res = JSON.parse(result);
            var companyId = res.distributor.distributor.id;
            var companySrc = res.distributor.distributor.company;
            var localZip = res.user_zip.zipcode.zipcode;

            var comp2 = companySrc.replace(/[^a-zA-Z ]/g, "");

            var company = comp2,
              comp = company.split(" ").join("-"),
              tolo = comp.toLowerCase();

            if (localZip.length === 5) {
              window.location.replace(
                "/a/distributors/" + companyId + "/" + tolo + "/" + localZip);
            } else {
              window.location.replace(
                "/a/distributors/" + companyId + "/" + tolo);
            }
          })
          .catch((error) => {
            window.location.replace("https://www.mountainvalleyspring.com/pages/no-delivery");
//             console.log("err");
//             wrap.find(".err").show();
//             setTimeout(function () {
//               wrap.find(".err").hide();
//             }, 3000);
           });
        
          }
	});
  }
  
  if($('.home-premise-footer').length) {
    var phonex = $('.phone-number').text(); 
    $('.home-premise-footer .phone-footer').text(phonex);
    $('.home-premise-footer .phone-footer').prop({
      href: 'tel:' + phonex
    });
  }
  
        $('#sel-contact').on('change', function () {
        console.log('ttr')
        var targ = $(this).val();
        console.log(targ)
        if (targ == "new") {
          var url = '/'; 
          if (url) { // require a URL
              window.location.href = 'https://www.mountainvalleyspring.com/pages/homedelivery';
          }
          return false;
        }
        else if (targ == "store") {
          
      		$('.contact-step-first').hide();
      		$('.contact-step-form').show();
      		$('.contact-step-form').addClass('show');
//           var url = '/'; 
//           if (url) { // require a URL
//               window.location.href = 'https://www.mountainvalleyspring.com/collections/all';
//           }
//           return false;
          
        }
        else if (targ == "water") {
          var url = '/'; 
          if (url) { // require a URL
            window.location.href = 'https://www.mountainvalleyspring.com/pages/report-water-quality';
          }
          return false;
          
            }
        else if (targ == "water report") {
          var url = '/'; 
          if (url) { // require a URL
            window.location.href = 'https://cdn.shopify.com/s/files/1/0282/3870/8845/files/2020_Water_Quality_Report.pdf?v=1602789515';
          }
          return false;
          
        }
        else if (targ == "service") {
//       		$('.contact-step-first').hide();
//       		$('.contact-step-form').show();
//       		$('.contact-step-form').addClass('show');
          var url = '/'; 
          if (url) { // require a URL
              window.location.href = 'https://www.mountainvalleyspring.com/pages/homedelivery#deliver-zip';
          }
          return false;
          
        }
        else if (targ == "other") {
      		$('.contact-step-first').hide();
      		$('.contact-step-form').show();
      		$('.contact-step-form').addClass('show');

        }
      });
  
  
        $('#continue-form').on('click', function () {
      		$('.contact-step-first').hide();
      		$('.contact-step-form').show();
      		$('.contact-step-form').addClass('show');
      });
  
})